import React from 'react';
import ControlRoomApp from './pages/ControlRoomApp';

const ControlRoomAppEntry: React.FC = () => {
  return <ControlRoomApp />;
};

export default ControlRoomAppEntry;
